var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("NumberActionItems", {
    attrs: {
      "current-number": _vm.number,
      "can-edit": _vm.numberContext.canEditNumber(_vm.number),
      "can-delete":
        !_vm.numberContext.activeNumber &&
        _vm.numberContext.canDeleteNumber(_vm.number),
      "pause-available": _vm.number.enabled && _vm.numberContext.isAdmin,
      "can-pause": !_vm.numberContext.activeNumber,
      "enable-available": !_vm.number.enabled && _vm.numberContext.isAdmin
    },
    on: {
      "on-edit": function($event) {
        return _vm.numberContext.showForm(_vm.number)
      },
      "on-delete": function($event) {
        return _vm.numberContext.confirmDeleteModal(_vm.number)
      },
      "on-pause": function($event) {
        return _vm.numberContext.confirmNumberPause(_vm.number)
      },
      "on-enable": function($event) {
        return _vm.numberContext.setNumberStatus(_vm.number, true)
      },
      activate: function($event) {
        return _vm.numberContext.showForm(_vm.number)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }